// extracted by mini-css-extract-plugin
module.exports = {"customTitle":"CreateUpdateTareModal_customTitle__q5s0W","tareModal":"CreateUpdateTareModal_tareModal__3BjKS","top":"CreateUpdateTareModal_top__1uEIf"};